import React from "react"
import { CacheProvider } from "@emotion/react"
import cacheRtl from "lib/material-ui/rtlCache"

export default function RtlProvider({ children }: { children: React.ReactNode }) {
  return (
    <CacheProvider value={cacheRtl}>
      {children}
    </CacheProvider>
  )
}
